export const FETCH_REFFERALS_DATA = "FETCH_REFFERALS_DATA";
export const FETCH_REFFERALS_SUCCESS = "FETCH_REFFERALS_SUCCESS";
export const FETCH_REFFERALS_FAILURE = "FETCH_REFFERALS_FAILURE";

export const FETCH_REFFERALS_EDIT_DATA = "FETCH_REFFERALS_EDIT_DATA";
export const FETCH_REFFERALS_EDIT_SUCCESS = "FETCH_REFFERALS_EDIT_SUCCESS";
export const FETCH_REFFERALS_EDIT_FAILURE = "FETCH_REFFERALS_EDIT_FAILURE";